export function extractLeadingMajorNumber(
    version?: string | null,
): string | null {
    if (!version) {
        return null;
    }
    const dotIndex = version.indexOf(".");
    if (dotIndex > 0) {
        return version.slice(0, dotIndex);
    }
    if (/^[0-9]+$/.test(version)) {
        return version;
    }
    return null;
}

export function isMajorVersionUpgrade(
    current?: string | null,
    recommended?: string | null,
): boolean {
    const currentMajor = extractLeadingMajorNumber(current);
    const recommendedMajor = extractLeadingMajorNumber(recommended);
    if (currentMajor === null || recommendedMajor === null) {
        return false;
    }
    return currentMajor !== recommendedMajor;
}
